import React from "react";

const Favourite = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M18.001 5.426c3.759-3.346 9.566-3.235 13.187.362a9.464 9.464 0 0 1 .378 13.068L17.998 32.33 4.434 18.856A9.466 9.466 0 0 1 4.81 5.788c3.624-3.592 9.42-3.713 13.19-.362ZM28.923 8.03c-2.4-2.383-6.272-2.48-8.784-.243l-2.136 1.9-2.138-1.898c-2.52-2.24-6.384-2.142-8.79.244a6.307 6.307 0 0 0-.307 8.649L18 27.838l11.232-11.154a6.309 6.309 0 0 0-.31-8.654Z"
              fill={fill}/>
    </svg>
);

export default Favourite;